export default {
    isEditGroupDialogOpen: false,
    isEditOptionDialogOpen: false,
    editGroupItem: {},
    editOptionItem: {},
    workerDeliveryFeeGroupList: [],
    workerDeliveryFeeGroupOptionList: [],
    selectedFeeGroup: {},
    // 라이더 수수료 그룹 변경 다이얼로그 전용
    isFeeGroupSelectDialogOpen: false,
};
